import { render, staticRenderFns } from "./BuyButtonLabel.vue?vue&type=template&id=60390abd"
import script from "./BuyButtonLabel.vue?vue&type=script&lang=js"
export * from "./BuyButtonLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports